import { useParams } from 'react-router'

const INVALID_CONVO_ID = -1

export const useConversationId: (onVisitorsPage?: boolean) => number | undefined = (
  onVisitorsPage
) => {
  const params = useParams<{ conversationId?: string }>()

  return onVisitorsPage
    ? undefined
    : (params.conversationId && Number(params.conversationId)) || INVALID_CONVO_ID
}
